import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IFinancialTransaction } from "../interfaces/financialTransaction";
import { IMessage } from "../interfaces/message";
import { IAppointment } from "../interfaces/appointment";

@Injectable({
    providedIn: 'root',
})

export class FakeDataService {

    getTransactions(): Observable<IFinancialTransaction[]> {
        return of([
            // {id: 1, date: 1733829144, doctor: 'احمد رضایی', category: 'عمومی', price: 199000, transactionId: 12563256, status: 1},
            // {id: 2, date: 1733829144, doctor: 'علی آقایی', category: 'قلب', price: 200000, transactionId: 12563256, status: 2},
            // {id: 3, date: 1733829144, doctor: 'ایمان یوسفی', category: 'جراحی', price: 167000, transactionId: 12563256, status: 3},
        ])
    }

    getMessages(): Observable<IMessage[]> {
        return of([
            // {id: 1, text: 'this is test', message: 'This is long message1', date: 1733829144, status: 1},
            // {id: 2, title: 'this is test', message: 'This is long message2', date: 1733829144, status: 2},
            // {id: 3, title: 'this is test', message: 'This is long message3', date: 1733829144, status: 2},
        ])
    }

    getAppointments(): Observable<IAppointment[]> {
        return of([
            // {id: 1, type: 'تصویری', date: 1733829144, status: 'پیش رو', doctor: 'علی آقایی', category: 'جراحی', price: 190000, link: 'https://test.medis.land'},
            // {id: 1, type: 'تلفنی', date: 1733829144, status: 'انجام شده', doctor: 'ایمان یوسفی', category: 'قلب', price: 190000, link: 'https://test.medis.land'},
        ])
    }
}